import bodyLockService from "../ui/bodyLockService";

document.querySelector('.js--element-generalCalculator') && document.querySelector('.js--element-generalCalculator').addEventListener('click', handleClick);

function handleClick (e) {
    if (e.target.matches('.quoteHelp')) {
        bodyLockService.lock();
    }
    if (e.target.matches('.closeQuoteTips')) {
        bodyLockService.unlock();
    }
}